import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { shortDateString } from 'ps-components/lib/formatters';
import './Rule.scss';

class Rule extends Component {
  static propTypes = {
    className: string,
    isSelected: bool,
    openDeleteModal: func,
    openSettingsModal: func,
    rule: object,
    setSelectedRule: func,
    toggleShowSelected: func
  };

  selectRule = () => {
    const { history, isSelected, rule, setSelectedRule, toggleShowSelected } = this.props;
    const deleteRoute = history.location.pathname.includes('/delete');
    const settingsRoute = history.location.pathname.includes('/settings');

    setSelectedRule(rule);
    if (!deleteRoute && !settingsRoute) history.push(`/market-analysis/rules-based-pricing/rules/${rule.id}`);
    if (!isSelected) toggleShowSelected();
  };

  render() {
    const { className, openDeleteModal, openSettingsModal, rule } = this.props;
    const date = rule.lastModified ? new Date(rule.lastModified) : new Date(rule.created);

    const name = rule.lastModifiedBy
      ? `${rule.lastModifiedBy.firstName} ${rule.lastModifiedBy.lastName}`
      : `${rule.createdBy.firstName} ${rule.createdBy.lastName}`;

    return (
      <div className={className} onClick={this.selectRule}>
        <div className="rule__row">
          <div className="rule__name">{rule.name}</div>
        </div>
        <div className="rule__row">
          <div className="rule__row-tite">Last Modified By</div>
        </div>
        <div className="rule__row">
          <div className="rule__row-data">
            {shortDateString(date)}&nbsp;&bull;&nbsp;{name}
          </div>
          <div className="rule__action-icons">
            <div className="rule__row-settings" onClick={() => openSettingsModal(rule)}>
              <i className="icon-cog" />
            </div>
            <div className="rule__row-delete" onClick={() => openDeleteModal(rule)}>
              <i className="icon-trash" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Rule;
